import {AppSchema} from './powersyncSchema';
import {
  AbstractPowerSyncDatabase,
  PowerSyncDatabase,
  WASQLiteOpenFactory,
  WASQLiteVFS,
} from '@powersync/web';
import LocalStorageService from './Services/LocalStorageService';
import {STORAGE_KEYS} from './Constants/AppConstants';
import AuthenticationService from './Services/AuthenticationService';
import {User} from 'oidc-client-ts';

class Connector {
  logOut: null | (() => Promise<void>) = null;
  constructor(logOutCallback: () => Promise<void>) {
    this.logOut = logOutCallback;
  }
  storageService = new LocalStorageService();
  authService = new AuthenticationService();

  async getToken() {
    let oidcAuth = this.storageService.getOidc();

    if (!oidcAuth) return null;

    let user = User.fromStorageString(oidcAuth);

    return user.access_token;
  }

  async fetchCredentials() {
    let token = await this.getToken();
    let powerSyncEndpoint = process.env.REACT_APP_POWERSYNC_ENDPOINT;

    if (token && powerSyncEndpoint) {
      return {
        endpoint: powerSyncEndpoint,
        token: token,
      };
    }

    return {
      endpoint: '',
      token: '',
    };
  }
  async uploadData(database: AbstractPowerSyncDatabase) {
    let token = await this.getToken();
    const batch = await database.getCrudBatch();

    if (batch === null) {
      return;
    }

    var backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    try {
      const result = await fetch(`${backendEndpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(batch.crud),
      });

      if (!result.ok) {
        throw new Error('Failed to upload data');
      }
      batch.complete();
    } catch (err) {
      console.log(err);
    }
  }
}

export const connectPowerSync = async (
  powersync: AbstractPowerSyncDatabase,
  logOut: () => Promise<void>,
) => {
  const connector = new Connector(logOut);

  //useArchive = false means powersync will ignore the useArchive flag and bring down all submissions
  await powersync.connect(connector, {params: {useArchive: false}});
};

export const setupPowerSync = async (): Promise<PowerSyncDatabase> => {
  let storageService = new LocalStorageService();
  let opsqliteKey = storageService.get(STORAGE_KEYS.OPSQLITE_ENCRYPTION_KEY);

  if (!opsqliteKey) {
    throw new Error('Encryption key not found');
  }

  const powerSync = new PowerSyncDatabase({
    schema: AppSchema,
    database: new WASQLiteOpenFactory({
      dbFilename: 'firsPowersyncDB.db',
      vfs: WASQLiteVFS.OPFSCoopSyncVFS,
      flags: {
        enableMultiTabs: typeof SharedWorker !== 'undefined',
      },
      encryptionKey: opsqliteKey!,
    }),
    flags: {
      enableMultiTabs: typeof SharedWorker !== 'undefined',
    },
  });

  await powerSync.init();
  return powerSync;
};

export const resetPowerSync = async (powersync: AbstractPowerSyncDatabase) => {
  await powersync.disconnectAndClear();
  setupPowerSync();
};
